import React, { useState, useEffect } from "react";
import axios from "../../../utills/api";
import {
  Card,
  CardBody,
  Button,
  Row,
  Col,
  Input,
  FormGroup,
} from "reactstrap";

import {
  RiHotelBedLine,
  RiDropLine,
  RiHomeSmileLine,
  RiCupLine,
  RiServiceLine,
  RiGiftLine,
  RiSparkling2Line,
  RiShirtLine,
  RiToolsLine,
  RiFridgeLine,
} from "react-icons/ri";

const Housekeeping = ({ booking }) => {
  const [notes, setNotes] = useState("");
  const [selectedServices, setSelectedServices] = useState([]);
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingServices, setLoadingServices] = useState(true);

  const iconMap = {
    "Room Cleaning": RiHomeSmileLine,
    "Deep Cleaning": RiSparkling2Line,
    "Bathroom Cleaning": RiDropLine,
    "Towel Change": RiDropLine,
    "Change Towels": RiDropLine,
    "Bedsheet Change": RiHotelBedLine,
    "Change Bedsheet": RiHotelBedLine,
    "Extra Pillow": RiGiftLine,
    "Extra Blanket": RiGiftLine,
    "Bar Change": RiCupLine,
    "Water Bottles": RiCupLine,
    Toiletries: RiGiftLine,
    "Iron Board": RiServiceLine,
    "Laundry Pickup": RiShirtLine,
    "Room Freshener": RiSparkling2Line,
    "Minibar Refill": RiFridgeLine,
    "Turn Down Service": RiHotelBedLine,
    "Maintenance Request": RiToolsLine,
    "Extra Hangers": RiServiceLine,
  };

  useEffect(() => {
    fetchHousekeepingServices();
  }, []);

  const fetchHousekeepingServices = async () => {
    try {
      setLoadingServices(true);

     const res = await axios.get(
  `/housekeeping/guest?tenantId=${booking.tenantId}`
);

      const data = Array.isArray(res.data)
        ? res.data.filter(
            (item) => item.status === "Active"
          )
        : [];

      setServices(data);
    } catch (err) {
      console.error(err);
      alert("Unable to load housekeeping services");
    } finally {
      setLoadingServices(false);
    }
  };

  const toggleService = (service) => {
    if (selectedServices.includes(service)) {
      setSelectedServices(
        selectedServices.filter(
          (s) => s !== service
        )
      );
    } else {
      setSelectedServices([
        ...selectedServices,
        service,
      ]);
    }
  };

  const submitRequest = async () => {
    try {
      setLoading(true);
      console.log({
  bookingId: booking.bookingId,
  tenantId: booking.tenantId,
  mobile: booking.mobile,
  roomNumber: booking.assignedRoom?.roomNumber,
  serviceType: selectedServices.join(", "),
  services: selectedServices,
  description: notes,
  preferredTime: "Right Now",
});
      await axios.post("/requests/guest", {
        bookingId: booking.bookingId,

        tenantId: booking.tenantId,

        mobile: booking.mobile,

        roomNumber:
          booking.assignedRoom?.roomNumber,

        serviceType:
          selectedServices.join(", "),

        services: selectedServices,

        description: notes,

        preferredTime: "Right Now",
      });
     
      alert(
        "Housekeeping request submitted successfully."
      );

      setSelectedServices([]);
      setNotes("");
    } catch (err) {
      console.log(err);

      alert("Unable to submit request");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        position: "relative",
        height: "100%",
        paddingBottom: "80px",
      }}
    >
      <h5 className="mb-3">
        Housekeeping Services
      </h5>

      <div
        style={{
          maxHeight: "75vh",
          overflowY: "auto",
          paddingRight: "5px",
        }}
      >
        {loadingServices ? (
          <div className="text-center p-4">
            Loading services...
          </div>
        ) : (
          <Row>
            {services.map((item) => {
              const Icon =
                iconMap[item.category] ||
                RiServiceLine;

              const selected =
                selectedServices.includes(
                  item.category
                );

              return (
                <Col
                  md={6}
                  xs={6}
                  className="mb-3"
                  key={item._id}
                >
                  <Card
                    className={
                      selected
                        ? "border-primary shadow"
                        : "border-0 shadow-sm"
                    }
                    style={{
                      borderRadius: 16,
                      cursor: "pointer",
                      background: selected
                        ? "#e8f4ff"
                        : "white",
                    }}
                    onClick={() =>
                      toggleService(
                        item.category
                      )
                    }
                  >
                    <CardBody className="text-center">
                      <Icon
                        size={34}
                        className="mb-2 text-primary"
                      />

                      <h6>
                        {item.category}
                      </h6>

                      {item.name && (
                        <small className="text-muted d-block">
                          {item.name}
                        </small>
                      )}

                      {selected && (
                        <small className="text-success">
                          Selected ✓
                        </small>
                      )}
                    </CardBody>
                  </Card>
                </Col>
              );
            })}
          </Row>
        )}

        <FormGroup>
          <Input
            type="textarea"
            rows="3"
            placeholder="Special instructions"
            value={notes}
            onChange={(e) =>
              setNotes(e.target.value)
            }
          />
        </FormGroup>
      </div>

      <div
        style={{
          position: "fixed",
          bottom: 20,
          left: 20,
          right: 20,
          zIndex: 999,
        }}
      >
        <Button
          color="primary"
          block
          size="lg"
          disabled={
            loading ||
            selectedServices.length === 0
          }
          onClick={submitRequest}
        >
          {loading
            ? "Submitting..."
            : `Submit Request${
                selectedServices.length
                  ? ` (${selectedServices.length})`
                  : ""
              }`}
        </Button>
      </div>
    </div>
  );
};

export default Housekeeping;